<template>
<div id="page-carga_ds">
    <div>
        <v-breadcrumbs :items="breadcrumbs">
            <v-icon slot="divider">forward</v-icon>
        </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12>
                <base-material-card color="primary" icon="library_books" title="Papelera de Informes Eliminados" class="elevation-1 px-5 py-3">
                
                    <v-card-text>
                          <v-card >
                               
                                <v-card-text style="margin-top:0px;">
                                    <v-client-table ref="vuetable" :data="bitacora.items" :columns="planta_referencia?columns_planta:columns" :options="planta_referencia?options_planta:options" class="elevation-2 pa-2">
                                <template slot="noResults">
                                    <v-alert :value="true" icon="info" color="info">No se encontro ningun registro</v-alert>
                                </template>
                              
                                <template slot="documento.valor_comercial_final" slot-scope="props">
                                    <div class="text-number">
                                        {{formatNumber(props.row.documento.valor_comercial_final, 2)}}
                                    </div>
                                </template>
                                <template slot="documento.valor_comercial_calculado" slot-scope="props">
                                    <div class="text-number">
                                        {{formatNumber(props.row.documento.valor_comercial_calculado, 2)}}
                                    </div>
                                </template>
                                <template slot="documento.fecha" slot-scope="props">
                                    <div >
                                        {{props.row.documento.fecha.substring(0,10)}}
                                    </div>
                                </template>
                                <template slot="fecha" slot-scope="props">
                                    <div >
                                        {{props.row.fecha.substring(0,10)}}
                                    </div>
                                </template>
                                <template slot="error" slot-scope="props">
                                    <div style="text-align:center">
                                        <v-icon small v-if="props.row.error==0" color="green">mdi-check-circle</v-icon>
                                        <v-icon small v-if="props.row.error==1" color="red">mdi-close-circle</v-icon>
                                    </div>
                                </template>
                                <template slot="actions" slot-scope="props" >
                                  

                                      
                                    <v-btn x-small fab dark color="primary" @click.native="downloadFile(props.row.key)" title="Descarga TXT" v-tippy>
                                        <v-icon>get_app</v-icon>
                                    </v-btn>
                                
                                </template>
                            
                            </v-client-table>
                        </v-card-text>
                            </v-card>
                   
                    </v-card-text>
                </base-material-card>
            </v-flex>
        </v-layout>
    </v-container>
</div>
</template>

<script>
import axios from "axios";
import moment from "moment";


export default {
    data() {
        return {
           
            fab: false,
            periodos: [],
            registro: "",
         
            tipos_documento:[],
            destinos_aduaneros:[],
          
            name: "datagrid",
           
           
            columns: [
                'fecha', 'usuario', 'tipo', 'documento.folio', 'documento.fecha', 
                'documento.cabecera.destino_aduanero', 'documento.cabecera.ejercicio', 'documento.cabecera.periodo_asociado', //'cabecera.consecutivo',
                'documento.valor_comercial_final',
                "actions"
            ],
            columns_planta: [
                'fecha', 'usuario','tipo', 'documento.folio',  'documento.fecha', 'documento.planta', 
                'documento.cabecera.destino_aduanero', 'documento.cabecera.ejercicio', 'documento.cabecera.periodo_asociado', //'cabecera.consecutivo',
                'documento.valor_comercial_final',
                "actions"
            ],
           
            
            show_loading: true,
            options: {
                filterable: [ 'fecha', 'usuario','tipo', 'documento.folio',  'documento.fecha', 
                'documento.cabecera.destino_aduanero', 'documento.cabecera.ejercicio', 'documento.cabecera.periodo_asociado', //'cabecera.consecutivo',
                'documento.valor_comercial_final',
                ],
                sortable: [ 'fecha', 'usuario','tipo', 'documento.folio',  'documento.fecha', 
                'documento.cabecera.destino_aduanero', 'documento.cabecera.ejercicio', 'documento.cabecera.periodo_asociado', //'cabecera.consecutivo',
                'documento.valor_comercial_final',
                ],

                headings: {
                    'fecha': 'Fecha Eliminación',
                    'usuario': 'Usuario',
                    'tipo': 'Tipo Documento',
                    'documento.fecha': 'Fecha Proceso SA31',
                    'documento.folio': 'Folio SAT',
                    'documento.cabecera.destino_aduanero': 'Destino Aduanero',
                    'documento.cabecera.ejercicio': 'Ejercicio',
                    'documento.cabecera.periodo_asociado': 'Periodo Afectado',
                    'documento.cabecera.consecutivo': 'No. Movimiento',
                    'documento.valor_comercial_final': 'Valor Comercial',
                    actions: "Operaciones"
                }
            },
            options_planta: {
                filterable: [ 'fecha', 'usuario','tipo', 'documento.folio', 'documento.planta', 'documento.fecha', 
                'documento.cabecera.destino_aduanero', 'documento.cabecera.ejercicio', 'documento.cabecera.periodo_asociado', //'cabecera.consecutivo',
                'documento.valor_comercial_final',
                ],
                sortable: [ 'fecha', 'usuario','tipo', 'documento.folio', 'documento.planta', 'documento.fecha', 
                'documento.cabecera.destino_aduanero', 'documento.cabecera.ejercicio', 'documento.cabecera.periodo_asociado', //'cabecera.consecutivo',
                'documento.valor_comercial_final',
                ],

                headings: {
                    'fecha': 'Fecha Eliminación',
                    'usuario': 'Usuario',
                    'tipo': 'Tipo Documento',
                    'documento.fecha': 'Fecha Proceso SA31',
                    'documento.folio': 'Folio SAT',
                    'documento.planta': 'Planta Referencia',
                    'documento.cabecera.destino_aduanero': 'Destino Aduanero',
                    'documento.cabecera.ejercicio': 'Ejercicio',
                    'documento.cabecera.periodo_asociado': 'Periodo Afectado',
                    'documento.cabecera.consecutivo': 'No. Movimiento',
                    'documento.valor_comercial_final': 'Valor Comercial',
                    actions: "Operaciones"
                }
            },
            show_loading: true,
            breadcrumbs: [{
                    text: "Inicio",
                    disabled: false,
                    to: "/home"
                },
                {
                    text: "Informes TXT",
                    disabled: true,
                    href: ""
                },
                {
                    text: "Papelera de Informes",
                    disabled: true,
                    href: ""
                }
            ],
            search: "",
            bitacora: {
                items: [],
                items_inicial: []
            },
        };
    },

    methods: {
       
     
   
        getBitacora: function () {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var rfc = this.$local_storage.get("rfc");
            let self = this;
            axios.post(this.$apiSA31 + "soluciona31/list_informes_eliminados/", {
                    'rfc': rfc,
                    'campos':{'fecha':1,'tipo':1, 'usuario':1, 'documento.fecha':1, 'documento.folio':1, 'documento.cabecera':1, 
                    'documento.valor_comercial_final':1, 
                    'key':1 , 'documento.planta':1
                     },
                  //   filtros: {"estatus": {"$in": ['Creado',  'Aplicado']}}, 
                })
                .then(response => {
                    self.bitacora.items = response.data;

                      self.bitacora.items.sort(function (a, b) {
                            return new Date(b.fecha) - new Date(a.fecha);
                      });

                    for (var k in this.bitacora.items) {
                       
                        self.bitacora.items[k].documento.fecha = moment(String(self.bitacora.items[k].documento.fecha)).format("YYYY-MM-DD");
                        self.bitacora.items[k].fecha = moment(String(self.bitacora.items[k].fecha)).format("YYYY-MM-DD");

                        if(self.bitacora.items[k].documento.planta == undefined)
                            self.bitacora.items[k].documento.planta = "";

                        if (self.bitacora.items[k].documento.cabecera != undefined){
                            let periodo = String(self.bitacora.items[k].documento.cabecera.periodo_asociado);
                            let p = self.periodos.filter(pp => {
                                return pp.clave == periodo
                            });
                            console.log(p);
                            console.log(periodo);
                            console.log(self.bitacora.items[k].documento.folio);

                            if (p.length > 0) {
                                self.bitacora.items[k].documento.cabecera.periodo_asociado = p[0].clave + " = " + p[0].nombre;
                            }

                        }
                      

                    }
                   

                    self.$root.$dialogLoader.hide();
                })
                .catch(error => {
                    console.log(error);
                    self.$root.$dialogLoader.hide();
                });
        },
    
        getPeriodos: function () {
    
            axios.post(this.$hostname + "apendices/lista/", {
                    'tabla': 32
                })
                .then(response => {
                 
                    this.periodos = response.data;
                    this.getTiposDocumento();
                    this.getDestinosAduaneros();
                    this.getBitacora();

                })
                .catch(error => {

                });
        },
        getTiposDocumento: function () {

                axios.post(this.$hostname + "apendices/lista/", {
                        'tabla': 31
                    })
                    .then(response => {
                        this.tipos_documento = response.data;
                    })
                    .catch(error => {

                    });
                },
        getDestinosAduaneros: function () {

                axios.post(this.$hostname + "apendices/lista/", {
                        'tabla': 30
                    })
                    .then(response => {
                        this.destinos_aduaneros = response.data;
                    })
                    .catch(error => {

                    });
        },        
      
    
     
        formatNumber: function (numero, decimales) {
            if (numero == undefined || numero == null || numero == "")
                numero = 0;
            numero = Number(numero);
            if (isNaN(numero)) {
                return "";
            } else
                return (numero).toFixed(decimales).replace(/\d(?=(\d{3})+\.)/g, '$&,');
        },
        downloadFile: function (nombre) {
            let rfc = this.$local_storage.get("rfc");
            rfc = rfc.toString().trim().toUpperCase();
          
            //alert(nombre);
            var datos = {
                id: nombre,
                bucket: "production.econnect.ds"
            };
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            axios.post(this.$hostname + 's3/download_url/', datos)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        var a = document.createElement("a");
                        document.body.appendChild(a);
                        a.style = "display: none";
                        a.href = res.data.mensaje;
                        a.target = "_blank";
                        a.click();
                        a.parentNode.removeChild(a);

                    } else {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
                            footer: '',
                        });
                    }
                })
                .catch((error) => {
                    var mensaje = "Ocurrió un error al descargar el archivo";
                    if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                        mensaje = error.response.data.mensaje;
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: mensaje,
                        footer: '',
                    });
                    console.log(error);
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });

        },
        },
      computed: {
        
        planta_referencia() {
            return  this.$local_storage.get("Modulo16") == 100 ;
        },
        
      
    },   
    mounted: function () {
       
        this.getPeriodos();

    },
};
</script>

<style scoped>
.table-bordered thead th,
.table-bordered thead td {
    font-size: x-small !important;
}

.text-number {
    text-align: right;
}
.VueTables>>>thead th {
  white-space: normal !important;
  text-align: center !important;
}
</style>
